import { DocumentFormVM } from 'front-office/view-models/document/document-form';

export const initialValues: DocumentFormVM = {
  numberAllowed: '',
  type: '',
  dateRelease: null,
  dateExpiration: null,
  municipality: undefined,
  note: '',
};
